import AppProvider from 'providers/app';
import AppRoutes from 'routes';
import React from 'react';

function App() {
  // render routes
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
